import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';



Snappy.Component.EduSticky= class EduSticky extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-sticky';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.onResize();
        this.updateStickyPosition();


    }

    setVars() {
        this.$document = $(document);
        this.$topSticky = this.$element.find('.js-sticky-top');
        this.$bottomStickyContainer = this.$element.find('.js-sticky-bottom-container');
        this.$bottomSticky = this.$element.find('.js-sticky-bottom');
        this.fixedNavHeight = (App.isDesktop) ? 70 : 65;
        this.isTopFixed = false;
        this.isBottomFixed = false;

    }

    setEventListeners() {
        this.$window.on(
            'resize:finished',
            (this.bindedResize = this.onResize.bind(this))
        );

        this.$document.on('scroll', this.onScroll.bind(this));

    }
    updateStickyPosition(isResised) {

        this.updateTopStickyPosition(isResised);

        if (this.$bottomSticky.length) {
            this.updateBottomStickyPosition(isResised);
        }
    }

    updateTopStickyPosition(isResised) {
        const topOffset1 = this.$element[0].getBoundingClientRect().top;
        if (topOffset1 <= this.fixedNavHeight && (!this.isTopFixed || isResised)) {
            this.$topSticky.css({ top: this.fixedNavHeight + 'px' });
            this.$topSticky.addClass('is-fixed');
            this.$element.css({paddingTop: this.topPanelHeight + 'px'});
            this.isTopFixed = true;
        } else if (topOffset1 > this.fixedNavHeight && (this.isTopFixed || isResised)) {
            this.$topSticky.css({ top: '' });
            this.$topSticky.removeClass('is-fixed');
            this.$element.css({paddingTop: ''});
            this.isTopFixed = false;
        }
    }

    updateBottomStickyPosition(isResised) {
        const topOffset2 = this.$bottomStickyContainer[0].getBoundingClientRect().top;

        if (topOffset2 < (this.fixedNavHeight + this.topPanelHeight) && (!this.isBottomFixed || isResised)) {
            this.$bottomSticky.css({top: this.topPanelHeight + this.fixedNavHeight +'px'});
            this.$bottomSticky.addClass('is-fixed');
            this.$bottomStickyContainer.css({paddingTop: this.botPanelHeight   + 'px'});
            this.isBottomFixed = true;

        } else if ((topOffset2 >= (this.fixedNavHeight + this.topPanelHeight)) && (this.isBottomFixed || isResised)){
            this.$bottomSticky.css({top: ''});
            this.$bottomSticky.removeClass('is-fixed');
            this.$bottomStickyContainer.css({paddingTop: ''});
            this.isBottomFixed = false;
        }
    }

    updateStickyDimensions() {
        this.topPanelHeight = this.$topSticky.outerHeight();
        if (this.$bottomSticky.length) {
            this.botPanelHeight = this.$bottomSticky.outerHeight();
        }



    }


    onScroll() {
        this.updateStickyPosition();
    }

    onResize() {
        this.fixedNavHeight = (App.isDesktop) ? 70 : 70;
        this.updateStickyDimensions();
        this.updateStickyPosition(true);


    }












};



// WEBPACK FOOTER //
// ./components/edu-sticky/scripts/edu-sticky.js